export default "__VITE_ASSET__flKbWWXT__"